export default __webpack_public_path__ + "media/zurb/img/lab/thumbnails/patterntap/type-ee6f747a4fa4f510dfecbcd09393f3c0.png";